// src/pages/VideoGalleryPage.js
import React from 'react';
import './VideoGalleryPage.css';

/** * IMPORTANT: To use local videos, you must import them 
 * so the build tool (Webpack/Vite) can resolve the path correctly.
 */
import localVid1 from '../assets/videos/demo.mp4';

function VideoGalleryPage() {
  const videos = [
    {
      id: 'video1',
      youtubeId: 'ed4PGOntwPk',
      type: 'youtube',
    },
    {
      id: 'video2',
      youtubeId: 'tkYx9n83zY8',
      type: 'youtube',
    },
    // Example of a local video entry
    {
      id: 'video-local-1',
      localPath: localVid1, // The imported variable
      type: 'local',
    },
    {
      id: 'video3',
      youtubeId: 'NGMOVzQS7MY',
      type: 'youtube',
    },
    {
      id: 'video4',
      youtubeId: 'qIxtXZ3W1nA',
      type: 'youtube',
    },
    {
      id: 'video5',
      youtubeId: 'upub-GnjUnI',
      type: 'youtube',
    },
    {
      id: 'video6',
      youtubeId: 'lzXc4fkuATw',
      type: 'youtube',
    },
    {
      id: 'video7',
      youtubeId: '1Pk9p6-arbk',
      type: 'youtube',
    },
    {
      id: 'video8',
      youtubeId: '307FX97h2OE',
      type: 'youtube',
    },
    {
      id: 'video9',
      youtubeId: '8KZHj75liqE',
      type: 'youtube',
    },
    {
      id: 'video10',
      youtubeId: 'h5lz1CUMloY',
      type: 'youtube',
    },
  ];

  return (
    <div className="video-gallery-container">
      <h1>Our Video Gallery</h1>
      <p className="gallery-intro">
        Explore our journey through these impactful videos, highlighting our programs, events, and the incredible progress of our students.
      </p>

      <div className="video-grid">
        {videos.map((video) => (
          <div key={video.id} className="video-item">
            <div className="video-embed-wrapper">
              
              {/* Conditional Rendering logic */}
              {video.type === 'youtube' ? (
                <iframe
                  src={`https://www.youtube.com/embed/${video.youtubeId}`}
                  title={`Video ${video.id}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              ) : (
                <video 
                  controls 
                  className="local-video-player"
                  preload="metadata"
                >
                  <source src={video.localPath} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VideoGalleryPage;